const { convertStringToBoolean } = require('../../utils/utils');

const isDevelopEnv = convertStringToBoolean(
  process.env.GATSBY_ADOBE_DEVELOP_ENV
);
const adobePreviewId = process.env.GATSBY_ADOBE_PREVIEW_ID;
const adobeProductionId = process.env.GATSBY_ADOBE_ID;

class ViewSDKClient {
  constructor(url, title, displayTitle) {
    this.readyPromise = new Promise(resolve => {
      if (window.AdobeDC) {
        resolve();
      } else {
        document.addEventListener('adobe_dc_view_sdk.ready', () => {
          resolve();
        });
      }
    });
    this.adobeDCView = undefined;
    this.pdfEvent = [];
    this.url = url;
    this.title = title;
    this.displayTitle = displayTitle;
    this.adobeID = isDevelopEnv ? adobePreviewId : adobeProductionId;
  }

  ready() {
    return this.readyPromise;
  }

  previewFile(divId, viewerConfig) {
    const config = {
      clientId: this.adobeID,
    };

    if (divId) {
      config.divId = divId;
    }

    const sanitisedDisplayTitle = () => {
      if (!this.displayTitle) return '';

      if (
        typeof this.displayTitle === 'object' &&
        this.displayTitle.displayTitle
      ) {
        return this.displayTitle.displayTitle;
      }

      if (typeof this.displayTitle === 'string') {
        return this.displayTitle;
      }

      return '';
    };

    this.adobeDCView = new window.AdobeDC.View(config);

    const previewFilePromise = this.adobeDCView.previewFile(
      {
        content: {
          location: {
            url: this.url,
          },
        },
        metaData: {
          fileName: sanitisedDisplayTitle(),
        },
      },
      viewerConfig
    );

    return previewFilePromise;
  }

  registerEventsHandler(addEventToDataLayer) {
    this.adobeDCView.registerCallback(
      window.AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
      event => {
        addEventToDataLayer(event);
      },
      {
        enablePDFAnalytics: true,
      }
    );
    return this.pdfEvent;
  }
}

export default ViewSDKClient;
